import { TAddExistingResource } from '@/console/features/groups/components/add-existing-resources/add-existing-resources.types';
import { TUseAddToGroupPermissionParams } from '@/console/features/groups/hooks/use-add-to-group-permission/use-add-to-group-permission.types';
import { usePermissionCheck } from '@/shared/features/permissions/hooks/use-permission-check/use-permission-check';

// The backend checks the update grant on the resource and on the target group.
export const useAddToGroupPermission = ({
  action,
  groupId,
  getResourceId,
}: TUseAddToGroupPermissionParams) => {
  const { can } = usePermissionCheck();

  return {
    hasAddPermission: can(action, groupId),
    isAddable: (resource: TAddExistingResource) =>
      resource.groupId !== groupId && can(action, getResourceId(resource)),
  };
};
